import React from 'react';
import { I18n } from 'aws-amplify';
import { Link } from 'aws-amplify-react';
import Typography from '@material-ui/core/Typography';

function getHrefByLocaleLaplaceidQa(theme) {
  if ('ja' === window.LAPLACEID_LOCALE) {
    if (theme) {
      return (
        <div>
          <p className="fontSizeSmall">{I18n.get('If you can not receive RESEND verification code, please check the question about Laplace ID.')}<br />
          <Link
            theme={theme}
            target='_blank'
            href='https://www.lapsys.co.jp/support/faq/id/'
          >
            {I18n.get('The question about Laplace ID')}
          </Link>
          </p>
        </div>
      );
    } else {
      return (
        <div>
          <ul>
            <li><Typography>{I18n.get('If you can not receive verification code, you can try to resend.')}</Typography></li>
            <li><Typography>{I18n.get('If you can not receive RESEND verification code, please check the question about Laplace ID.')}</Typography></li>
          </ul>
          <a
            className={'questionLink'}
            href = 'https://www.lapsys.co.jp/support/faq/id/'
            target = '_blank'
            rel = 'noopener noreferrer'
          >
            {I18n.get('The question about Laplace ID')}
          </a>
        </div>
      );
    }
  } else {
    if (theme) {
      return (<div></div>);
    } else {
      return (
        <div>
          <ul>
            <li><Typography>{I18n.get('If you can not receive verification code, you can try to resend.')}</Typography></li>
          </ul>
        </div>
      );
    }
  }
}
export default getHrefByLocaleLaplaceidQa;

